import { Injectable, Inject } from '@angular/core';
import { Http, RequestOptionsArgs, Headers, Response, ResponseContentType } from '@angular/http';
import { EnvironmentProvider } from './browser-providers';
import { Environment } from '../../environments/enviroment.model';
import { Cliente } from '../cliente/cliente.model';
import { Observable } from 'rxjs/Observable';
import { Producto } from '../productos/producto.model';
import { Pedido } from '../pedido/pedido.model';

@Injectable()
export class ArchivoService {

  private tokenId = 'jwtToken';
  protected backendUrl: string;
  constructor(
    protected http: Http,
    @Inject(EnvironmentProvider) env: Environment,
  ) {
    this.backendUrl = env.endpoints.apiBack;
  }

  getArchivo(id: number): Observable<Blob> {
    return this.http.get(this.buildUrl(Pedido.path + 'pdf/' + id),
    this.buildRequestOptions({ responseType: ResponseContentType.Blob }))
    .map((res: Response) => res.blob());
  }

  public buildUrl(path: string) {
    return this.backendUrl + encodeURI(path);
  }

  private buildRequestOptions(options: RequestOptionsArgs = {}) {
    options.headers = options.headers || new Headers();
    options.headers.append('Content-Type', 'application/ld+json');
    const token = this.token;
    if (token) {
      options.headers.append('Authorization', 'Bearer ' + token);
    }
    return options;
  }

  get token() {
    return localStorage.getItem(this.tokenId);
  }


}



// WEBPACK FOOTER //
// ./src/app/core/archivo.service.ts